var script = {
    config: {},
    steps: [{
    	content: "This is the Summary Report. It shows the type of patients by the number of visits and the provider's specialty.",
    },{
    	content: "This Report provides insight into which specialities are driving volumes to your facilities.",
    }]
};

export default script;